<template>
  <div class="container">
    <b-col md="12">
      <div
        v-show="false"
        id="floating-panel"
        class="floating-panel"
      >
        <section id="card-actions">
          <validation-observer
            #default="{ handleSubmit }"
            ref="refFormObserver"
          >
            <b-form
              class="p-2"
              @submit.prevent="handleSubmit(onSubmit)"
              @reset.prevent="resetForm"
            >
              <b-row>
                <b-col md="12">
                  <b-card-actions
                    title="OPCIONES DE FILTRO"
                    action-collapse
                  >
                    <b-card-text>
                      <b-row>
                        <b-col md="12">
                          <validation-provider
                            #default="validationContext"
                            name="Proyecto"
                            rules="required"
                          >
                            <b-form-group
                              label="Proyecto"
                              label-for="proyecto"
                              :state="getValidationState(validationContext)"
                            >
                              <b-form-select
                                v-model="selectProyecto"
                                type="select"
                                class="custom-select"
                              >
                                <option value="">
                                  SELECCIONE::
                                </option>
                                <option
                                  v-for="proy in optionProyecto"
                                  :key="proy.idProyecto"
                                  :value="proy.idProyecto"
                                >
                                  {{ proy.nombre }}
                                </option>
                              </b-form-select>
                              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                                {{ validationContext.errors[0] }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="12">
                          <validation-provider
                            #default="validationContext"
                            name="tipoPersona"
                            rules="required"
                          >
                            <b-form-group
                              label="ENCUESTA "
                              label-for="encuesta"
                            >
                              <b-form-select
                                v-model="selectEncuesta"
                                type="select"
                                class="custom-select"
                              >
                                <option value="">
                                  SELECCIONE UNA ENCUESTA::
                                </option>
                                <option
                                  v-for="quiz in optionEncuesta"
                                  :key="quiz.idEncuesta"
                                  :value="quiz.idEncuesta"
                                >
                                  {{ quiz.titulo }}
                                </option>
                              </b-form-select>
                              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                                {{ validationContext.errors[0] }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="12">
                          <b-form-group
                            label="Usuario"
                            label-for="usuario"
                          >
                            <b-form-select
                              v-model="selectUsuario"
                              type="select"
                              class="custom-select"
                            >
                              <option value="">
                                SELECCIONE::
                              </option>
                              <option
                                v-for="user in optionUsuario"
                                :key="user.idUsuario"
                                :value="user.idUsuario"
                              >
                                {{ user.login }}
                              </option>
                            </b-form-select>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="6">
                          <b-form-group
                            label="FECHA INICIO"
                            label-for="fechaInicio"
                          >
                            <b-form-datepicker
                              id="fechaInicio"
                              v-model="fechaInicio"
                              class="mb-1"
                              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                              locale="es"
                              placeholder="Selecccione fecha"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="6">
                          <b-form-group
                            label="FECHA FINAL"
                            label-for="fechaFinal"
                          >
                            <b-form-datepicker
                              id="fechaFinal"
                              v-model="fechaFinal"
                              class="mb-1"
                              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                              locale="es"
                              placeholder="Selecccione fecha"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col
                          md="2"
                        >
                          <download-excel
                            v-show="excelFicha"
                            class="btn btn-default"
                            :fetch="()=>{return getFicha()}"
                            worksheet="Ficha"
                            name="reporte_ficha.xls"
                          >
                            <b-img
                              :src="imgExcel"
                              width="24"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Descargar Fichas"
                            />
                          </download-excel>
                        </b-col>
                        <b-col
                          md="10"
                          style="text-align:end"
                        >
                          <b-form-group
                            label-for="acciones2"
                          >
                            <b-button
                              variant="primary"
                              type="submit"
                            >
                              <feather-icon
                                icon="MapIcon"
                                class="mr-50 fa-green"
                              />
                              Mostrar Reporte
                            </b-button>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-card-actions>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </section>
      </div>
      <div id="right-panel" />
      <div id="map">
        <b-row
          v-if="stateMapaParcela"
        >
          <gmap-map
            ref="map"
            :center="center"
            map-type-id="satellite"
            :zoom="17.9"
            style="width: 100%; height: 600px"
          >
            <gmap-marker
              v-for="(m, index) in markersParcela"
              :key="index"
              :position="m.position"
              :title="m.title"
              :clickable="true"
              :draggable="false"
            />
            <gmap-polyline
              :options="{ strokeColor: '#34C942', }"
              :path="paths"
              :editable="false"
              :draggable="false"
            />
          </gmap-map>
        </b-row>
      </div>
    </b-col>
  </div>
</template>
<script>
import store from '@/store'
import {
  BRow, BCol, BCardText, BFormSelect, BFormGroup, BButton, BFormDatepicker, BForm, BFormInvalidFeedback, BImg, VBTooltip,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required } from '@validations'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import moment from 'moment'
import axios from 'axios'
import formValidation from '@core/comp-functions/forms/form-validation'
import imgMarker from '../../../assets/images/encuesta/pin3.png'
import imgPinParcela from '../../../assets/images/encuesta/pinparcela.png'
import imgExcel1 from '../../../assets/images/encuesta/excel.png'

export default {
  components: {
    BCol,
    BRow,
    BCardActions,
    BCardText,
    BFormSelect,
    BFormGroup,
    BButton,
    BFormDatepicker,
    BForm,
    ValidationProvider,
    ValidationObserver,
    BFormInvalidFeedback,
    BImg,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    latitude: {
      type: Number,
      default: -6.0220945,
    },
    longitude: {
      type: Number,
      default: -76.9884157,
    },
    title: {
      type: String,
      default: 'Título de Marcador',
    },
  },
  data() {
    return {
      required,
      time1: '',
      modalShow: false,
      excelFicha: false,
      excelTracking: false,
      trackingShow: false,
      titleModal: 'Tracking',
      isBusyTracking: false,
      isAddNewActive: false,
      dataTracking: {},
      typeAction: 'view',
      imgExcel: imgExcel1,
      selectProyecto: '',
      selectUsuario: '',
      selectEncuesta: '',
      selectTipoReporte: '',
      fechaInicio: '',
      optionUsuario: [],
      optionProyecto: [],
      optionEncuesta: [],
      avatars: [
        { avatar: require('@/assets/images/portrait/small/avatar-s-9.jpg'), fullName: 'Billy Hopkins' },
        { avatar: require('@/assets/images/portrait/small/avatar-s-6.jpg'), fullName: 'Amy Carson' },
        { avatar: require('@/assets/images/portrait/small/avatar-s-8.jpg'), fullName: 'Brandon Miles' },
        { avatar: require('@/assets/images/portrait/small/avatar-s-7.jpg'), fullName: 'Daisy Weber' },
        { avatar: require('@/assets/images/portrait/small/avatar-s-20.jpg'), fullName: 'Jenny Looper' },
      ],
      fechaFinal: '',
      center: { lat: -6.0220945, lng: -76.9884157 },
      markerOptions: {
        url: imgMarker,
        // size: { width: 50, height: 50, f: 'px', b: 'px' },
        // scaledSize: { width: 50, height: 50, f: 'px', b: 'px' },
      },
      /* markers: [
        {
          position: { lat: this.latitude, lng: this.longitude },
          title: this.title,
        },
      ], */
      markerOptionParcela: {
        url: imgPinParcela,
        size: { width: 60, height: 60, f: 'px', b: 'px' },
        scaledSize: { width: 60, height: 60, f: 'px', b: 'px' },
      },
      markersParcela: [],
      descripcionSurvey: '',
      currentMidx: null,
      infoWinOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      markers: [],
      paths: [],
      dataParcela: {},
      unsubscribe2: null,
      stateMapaParcela: false,
    }
  },
  created() {
    console.log(`iniciando component.. ${this.$store.state.gsencuesta.operacion}`)
    if (this.$store.state.gsencuesta.operacion === 'show') {
      this.dataParcela = this.$store.state.gsencuesta.data
      // console.log(this.dataParcela)
      this.loadParcelaCoordena(this.dataParcela)
      // this.stateMapaParcela = true
    }
    /* this.unsubscribe2 = this.$store.subscribe(mutation => {
      console.log('hola')
      if (this.$store.state.gsencuesta.operacion === 'list') {
        console.log(this.$store.state.gsencuesta.operacion)
      } else {
        this.dataParcela = mutation.payload.data
        console.log(this.dataParcela)
      }
    }) */
  },
  /* destroyed() {
    this.unsubscribe2()
  }, */
  setup() {
    const blankData = {
      idEncuesta: 0,
    }
    const selectEncuesta = ref('')
    const formData = ref(JSON.parse(JSON.stringify(blankData)))/* desestructuracion de  blankData */
    const resetData = () => {
      formData.value = JSON.parse(JSON.stringify(blankData))
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetData)

    return {
      formData,
      refFormObserver,
      getValidationState,
      resetForm,
      selectEncuesta,
    }
  },
  mounted() {
    this.fechaInicio = moment().format('YYYY-MM-DD')
  },
  methods: {
    async getFicha() {
      const response = await axios.get(`http://dev.regionsanmartin.gob.pe/gsencuesta/api/v1/encuesta/findFichaParsed?idEncuesta=${this.selectEncuesta}&fechaInicio=${this.fechaInicio}&fechaFinal=${this.fechaFinal}&idUsuario=${this.selectUsuario}`)
      return response.data
    },
    async getTracking(idFicha) {
      const response = await axios.get(`assd/${idFicha}`)
      return response.data
    },
    loadImgMultimedia(url) {
      this.infoContent.multimediaStartLogo = url
    },
    okMdlTracking(ev) {
      ev.preventDefault()
    },
    refetchDataTracking() {
      this.trackingShow = false
    },
    showError(error) {
      let errorMessage = 'Intentelo en otro momento.'
      if (error.response) {
        errorMessage = error.response.data.errorMessage
      }
      this.$bvToast.toast(errorMessage, {
        title: 'Ha ocurrido un error',
        variant: 'danger',
        solid: true,
      })
    },
    toggleInfoWindow(marker, idx) {
      moment.locale('es')

      this.infoWindowPos = marker.position
      // this.infoContent = marker

      this.descripcionSurvey = marker.encuesta.descripcion
      const localLocale = moment(marker.fechaInicio) // createdAt
      const dateCreate = moment(localLocale).locale('es').format('dddd, LL')
      let dayShort = moment(localLocale).locale('es').format('dddd')
      const hour = moment(localLocale).locale('es').format('h:mm:ss a')
      dayShort = dayShort.substring(0, 3)
      const dateNumber = moment(marker.createdAt).locale('es').format('DD')
      if (this.descripcionSurvey.length > 57) {
        this.descripcionSurvey = this.descripcionSurvey.substring(0, 57)
        this.descripcionSurvey = `${this.descripcionSurvey} ...`
      }

      this.infoContent = {
        idFicha: marker.idFicha,
        multimedia: marker.multimedia,
        multimediaStartLogo: (marker.multimedia.length > 0) ? marker.multimedia[0].url : `https://apimesa.regionsanmartin.gob.pe/gsencuesta/api/v1/recurso/encuesta/${marker.encuesta.idEncuesta}/thumbnail`,
        descripcion: this.descripcionSurvey,
        fullDescripcion: marker.encuesta.descripcion,
        titulo: marker.encuesta.titulo,
        createdAt: dateCreate,
        time: marker.time,
        hour,
        dateNumber,
        dayShort,
        latitud: marker.latitud, // para centrar en tracking
        longitud: marker.longitud, // para centrar en tracking
        tracking: marker.tracking, // PASAMOS TODO EL TRAKCING ALLA VALIDAMOS SI HAY TRACKING
      }
      // this.infoContent = this.getInfoWindowContent(marker)
      // check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    },
    getInfoWindowContent(marker) {
      moment.locale('es')
      let work = marker.encuesta.descripcion
      const localLocale = moment(marker.createdAt)
      const dateCreate = moment(localLocale).locale('es').format('dddd, LL')
      let dayShort = moment(localLocale).locale('es').format('dddd')
      const hour = moment(localLocale).locale('es').format('h:mm:ss a')
      dayShort = dayShort.substring(0, 3)
      const dateNumber = moment(marker.createdAt).locale('es').format('DD')
      if (work.length > 57) {
        work = work.substring(0, 57)
        work = `${work} ...`
      }
      // console.log(marker)
      return (`<div class="container"> <div class="row"><div class="col-sm-12" style="max-width: 316px !important;max-height: 500px !important;"><div 
    class="card card-developer-meetup"
  >
    <div class="bg-light-primary rounded-top text-center">
      <img
        src="https://test.regionsanmartin.gob.pe:6443/gsencuesta/api/v1/recurso/encuesta/${marker.encuesta.idEncuesta}/thumbnail"
        alt="Meeting Pic"
        height="170"
      />
    </div>
    <div class="card-body"><!----><!----><div class="meetup-header d-flex align-items-center"><div class="meetup-day"><h6 class="mb-0">${dayShort.toUpperCase()}</h6><h3 class="mb-0">${dateNumber}</h3></div><div class="my-auto"><h5 class="card-title mb-25" style="font-size: 1.0rem !important">${marker.encuesta.titulo}</h5><p class="card-text item-description" data-toggle="tooltip" data-placement="top" title="${marker.encuesta.descripcion}"> ${work}</p></div></div><div class="media"><div class="media-aside mr-1 align-self-start"><span class="b-avatar badge-light-primary rounded" style="width: 34px; height: 34px;"><span class="b-avatar-custom"><svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-calendar"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg></span><!----></span></div><div class="media-body"><h6 class="mb-0">${dateCreate}</h6><small>${hour}</small></div></div><div class="media"><div role="group" class="b-avatar-group mt-2 pt-50"><div class="b-avatar-group-inner" style="padding-left: calc(4.95px); padding-right: calc(4.95px);"><span class="b-avatar pull-up badge-secondary rounded-circle" style="margin-left: calc(-4.95px); margin-right: calc(-4.95px); width: 33px; height: 33px;"><span class="b-avatar-img"><img src="/img/avatar-s-9.397f0acd.jpg" alt="avatar"></span><!----></span><span class="b-avatar pull-up badge-secondary rounded-circle" style="margin-left: calc(-4.95px); margin-right: calc(-4.95px); width: 33px; height: 33px;"><span class="b-avatar-img"><img src="/img/avatar-s-6.0f4533ab.jpg" alt="avatar"></span><!----></span><span class="b-avatar pull-up badge-secondary rounded-circle" style="margin-left: calc(-4.95px); margin-right: calc(-4.95px); width: 33px; height: 33px;"><span class="b-avatar-img"><img src="/img/avatar-s-8.d6c23222.jpg" alt="avatar"></span><!----></span><span class="b-avatar pull-up badge-secondary rounded-circle" style="margin-left: calc(-4.95px); margin-right: calc(-4.95px); width: 33px; height: 33px;"><span class="b-avatar-img"><img src="/img/avatar-s-7.cb1b1e65.jpg" alt="avatar"></span><!----></span><span class="b-avatar pull-up badge-secondary rounded-circle" style="margin-left: calc(-4.95px); margin-right: calc(-4.95px); width: 33px; height: 33px;"><span class="b-avatar-img"><img src="/img/avatar-s-20.32972323.jpg" alt="avatar"></span><!----></span><h6 class="align-self-center cursor-pointer ml-1 mb-0"> +42 </h6></div></div></div>
    <br>
    <div class="row">
     <div class="col-sm-12">
       <button
        class="btn btn-primary btn-block"
        onclick='loadTracking(${marker.idFicha});'
      >
        GENERAR TRACKING
      </button>
     </div>
    </div>
  </div></div><div></div>`)
    },
    loadTracking(ficha) {
      this.trackingShow = true
      this.$refs.map.$mapPromise.then(map => {
        let indexArray = null
        const bottomCenterControls = map.controls[window.google.maps.ControlPosition.TOP_CENTER]
        bottomCenterControls.forEach((element, index) => {
          if (element.id !== null && element.id === 'floating-tracking') {
            indexArray = index
            // console.log(`indexddd ${element.id}`)
          }
        })
        if (indexArray) {
          // bottomCenterControls.removeAt(indexArray)
        }
        // console.log(bottomCenterControls)
        const myControl = document.getElementById('floating-tracking')// floating-panel
        myControl.index = 2 // Esto es importante sino arroja error.
        map.controls[window.google.maps.ControlPosition.TOP_CENTER].setAt(1, myControl)
        this.dataTracking = ficha
        this.isBusyTracking = true
        this.isAddNewActive = true
        this.$refs.refTrackingForm.dataForm(ficha)
      })
    },
    onSubmit() {
      this.formData.idEncuesta = this.selectEncuesta
      this.formData.fechaInicio = this.fechaInicio
      this.formData.fechaFinal = this.fechaFinal
      this.formData.idUsuario = this.selectUsuario
      this.time1 = '0 min'
      this.markers = []
      const service = 'gsencuesta/ENCUESTA_FIND_FICHA'
      store.dispatch(service, this.formData)
        .then(response => {
          response.forEach(item => {
            // const fi = (!item.fechaInicio || item.fechaInicio === null) ? '' : moment(item.fechaInicio).format('YYYY-MM-DD')
            const ff = (!item.fechaFin || item.fechaFin === null) ? '' : moment(item.fechaFin).format('YYYY-MM-DD')
            const a = moment(item.fechaInicio)
            const b = moment(item.fechaFin)
            const m = b.diff(a, 'minutes')
            // const h = b.diff(a, 'hours')
            // const m = b.diff(a, 'minutes')
            /* if (m > 60) {
              const h1 = m / 60
              const m1 = m % 60
              this.time1 = `${Math.round(h1)} h, ${m1} m`
            } else {
              this.time1 = `${m} m`
            } */
            const textMin = (m > 1) ? 'Minutos' : 'Minuto'
            this.time1 = `${m} ${textMin}`

            this.markers.push(
              {
                idFicha: item.idFicha,
                position: { lat: parseFloat(item.latitud), lng: parseFloat(item.longitud) },
                title: item.encuestado.nombre,
                encuestado: item.encuestado,
                fechaFin: ff,
                fechaInicio: item.fechaInicio,
                latitud: item.latitud,
                longitud: item.longitud,
                createdAt: item.createdAt,
                encuesta: item.encuesta,
                multimedia: item.multimedia,
                tracking: item.tracking,
                time: this.time1,
              },
            )
          })
          this.excelFicha = true
        })
        .catch(() => {
          // console.log(error)
          // emit('error-data', error)
        })
    },
    async loadParcelaCoordena(dataParcela) {
      this.markersParcela = []
      this.paths = []
      if (dataParcela.parcelaCoordenada.length > 0 && dataParcela !== null) {
        dataParcela.parcelaCoordenada.forEach((item, index) => {
          this.paths.push({
            lat: parseFloat(item.latitud),
            lng: parseFloat(item.longitud),
          })
          this.markersParcela.push({
            position: { lat: parseFloat(item.latitud), lng: parseFloat(item.longitud) },
          })
          if (index === (dataParcela.parcelaCoordenada.length - 1) % 2) {
            this.center = {
              lat: parseFloat(item.latitud),
              lng: parseFloat(item.longitud),
            }
          }
        })
        this.stateMapaParcela = true
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.floating-panel{
    position: absolute !important;
    top: 10px !important;
    z-index: 5 !important;
    left: 24% !important;
    width: 50% !important;
}
.floating-tracking{
    position: absolute !important;
    left: 0% !important;
    top: 10px !important;
    z-index: 5 !important;
    width: 100% !important;
}
</style>
